import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@electric-sql+pglite@0.2.13_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0._e4c2c47b1fff6881a4ed34ec8e518833/node_modules/nuxt/dist/pages/runtime/validate.js";
import authorization_45global from "/app/middleware/authorization.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@electric-sql+pglite@0.2.13_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0._e4c2c47b1fff6881a4ed34ec8e518833/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authorization_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_@electric-sql+pglite@0.2.13_magicast@0.3.5_next-auth@4.21.1__265c6c7019054ee318c4725a9c620c64/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}